var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3134_19577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3134_19577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0533 12.0005L15.1264 7.92737C15.2649 7.78892 15.3357 7.61489 15.3389 7.40527C15.3421 7.19568 15.2713 7.01844 15.1264 6.87357C14.9816 6.72869 14.8059 6.65625 14.5995 6.65625C14.3931 6.65625 14.2175 6.72869 14.0726 6.87357L9.5784 11.3678C9.4848 11.4614 9.41877 11.5601 9.38032 11.6639C9.34186 11.7678 9.32262 11.88 9.32262 12.0005C9.32262 12.121 9.34186 12.2332 9.38032 12.337C9.41877 12.4408 9.4848 12.5396 9.5784 12.6331L14.0726 17.1274C14.2111 17.2658 14.3851 17.3367 14.5947 17.3399C14.8043 17.3431 14.9816 17.2723 15.1264 17.1274C15.2713 16.9825 15.3438 16.8069 15.3438 16.6005C15.3438 16.3941 15.2713 16.2184 15.1264 16.0736L11.0533 12.0005Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.f43da30c761eb2b1416f1b95cf716e9e.svg";
export { ForwardRef as ReactComponent };